import { BridgeConfig } from '@digitaz/bridge-sdk-client';

export const getBridgeConfig = (): BridgeConfig => {
  const isDev = process.env.NODE_ENV === 'development';

  const config = {
    miniapp: 'bina',
    routesHideTopSafeAre: [/\/items\/\d+$/],
    eventOriginRule: /^http:\/\/(\w+\.)?localhost/
  };

  if (typeof window !== 'undefined' && !isDev) {
    config.eventOriginRule = new RegExp(
      `^https://(\\w+\\.)?${new URL(window.location.href).hostname}/?$`
    );
  }

  return config;
};
